<template>
	<div class="student-login">
		<div class="tab">
			<span @click="loginType = 'account'" :class="loginType == 'account' ? 'on' : ''">账号</span>
			<span @click="loginType = 'qrcode'" :class="loginType == 'qrcode' ? 'on' : ''">扫码</span>
		</div>

		<div v-if="loginType == 'account'">
			<input class="input" placeholder="学生账号" v-model="username" @keyup.enter="logins" />
			<input class="input" placeholder="密码" type="password" v-model="password" @keyup.enter="logins" />
			<button class="btn" @click="logins">登录</button>
		</div>

		<div v-else class="scan-box">
			<button @click="startCamera" class="upload-btn camera-btn">打开摄像头扫码</button>
			<button @click="uploadImg" class="upload-btn" style="margin-top: 10px;">上传二维码图片</button>

			<input ref="file" type="file" accept="image/png,image/jpg,image/jpeg" style="display:none"
				@change="doUpload" />
			<div class="tip">{{ msg }}</div>
		</div>

		<div class="camera-mask" v-if="showCamera">
			<video ref="video" autoplay playsinline webkit-playsinline></video>
			<div class="scan-line"></div>
			<button class="close-camera" @click="stopCamera">关闭</button>
		</div>

		<div class="mask" v-if="showMask">
			<div class="mask-content">
				<div class="loading-text">登录中...</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		loginType,
		logUserText,
		userInfo
	} from '../login.js'
	import jsQR from 'jsqr'

	export default {
		name: 'StudentLogin',
		data() {
			return {
				loginType: 'account',
				username: '',
				password: '',
				msg: '',
				login: null,
				autoLoginFlag: false,
				showCamera: false,
				stream: null,
				scanTimer: null,
				showMask: false,
			}
		},
		mounted() {
			this.checkUrlQrParams()
			// window.addEventListener("keyup", this.handleEnterKey);
		},
		beforeDestroy() {
			this.stopCamera()
			// window.removeEventListener("keyup", this.handleEnterKey);
			// if (this.codeTimer) clearInterval(this.codeTimer);
		},
		methods: {
			loginOpen(text) {

				this.login = this.$loading({
					lock: true,
					text: text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close()
				}
			},
			// ===================== 全平台兼容摄像头 =====================
			async startCamera() {
				try {
					this.showCamera = true
					await this.$nextTick()
					const video = this.$refs.video

					// 全平台兼容配置
					const constraints = {
						video: {
							facingMode: 'environment', // 优先后置摄像头（手机全兼容）
							width: {
								ideal: 1280
							},
							height: {
								ideal: 720
							}
						},
						audio: false
					}

					// 兼容 iOS / Android / 浏览器
					this.stream = await navigator.mediaDevices.getUserMedia(constraints)
					video.srcObject = this.stream

					video.onloadeddata = () => {
						video.play().catch(() => {}) // 兼容iOS静默播放
						this.startQrScan()
					}
				} catch (e) {
					this.$message.error('摄像头打开失败：' + e.message)
					this.showCamera = false
				}
			},
			startQrScan() {
				clearInterval(this.scanTimer)
				this.scanTimer = setInterval(() => {
					if (!this.showCamera) return
					const video = this.$refs.video
					if (!video || video.paused || video.ended) return

					const canvas = document.createElement('canvas')
					const w = video.videoWidth || 640
					const h = video.videoHeight || 480
					canvas.width = w
					canvas.height = h

					const ctx = canvas.getContext('2d')
					ctx.drawImage(video, 0, 0, w, h)
					const imageData = ctx.getImageData(0, 0, w, h)
					const code = jsQR(imageData.data, w, h)

					if (code) {
						this.showMask = true
						this.stopCamera()
						this.handleQrCodeData(code.data)
					}
				}, 300)
			},
			stopCamera() {
				this.showCamera = false
				clearInterval(this.scanTimer)
				if (this.stream) {
					this.stream.getTracks().forEach(t => t.stop())
					this.stream = null
				}
			},
			// ============================================================

			// 你原有代码 100% 完全没动！
			async logins() {
				if (!this.username || !this.password) {
					this.$message && this.$message.warning("请输入账号密码");
					return;
				}
				this.loginOpen('登陆中...')
				try {
					let loginT = await loginType(this.API, this.username, this.password, 3)
					if (loginT === 'true') {
						this.$message.success('登录成功')
						this.noLogin()
						this.$router.push('/student/home')

					} else {
						this.noLogin()
						this.$message.error(loginT)
					}
				} catch (err) {
					this.$message.error('登录请求失败：' + err.message)
					this.noLogin()
				} finally {

				}
			},
			uploadImg() {
				if (this.$refs.file) {
					this.$refs.file.value = ''
					this.msg = ''
					this.$refs.file.click()
				}
			},
			doUpload(e) {
				const file = e.target.files[0]
				if (!file) return
				const validTypes = ['image/png', 'image/jpg', 'image/jpeg']
				if (!validTypes.includes(file.type)) {
					this.$message.error('请上传PNG/JPG/JPEG格式的图片')
					return;
				}
				const reader = new FileReader()
				const that = this
				reader.onload = function(e) {
					const img = new Image()
					img.onload = function() {
						try {
							const canvas = document.createElement('canvas')
							const ctx = canvas.getContext('2d')
							canvas.width = img.width
							canvas.height = img.height
							ctx.drawImage(img, 0, 0)
							const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
							const code = jsQR(imageData.data, imageData.width, imageData.height)
							if (code) {
								that.msg = '上传识别成功'
								that.handleQrCodeData(code.data)
							} else {
								that.msg = '未识别到二维码内容'
							}
						} catch (innerErr) {
							that.$message.error('二维码解析失败')
							that.msg = '解析失败'
						}
					}
					img.src = e.target.result
				}
				reader.readAsDataURL(file)
			},
			getHashParams() {
				const params = {}
				const hash = window.location.hash.slice(1)
				if (!hash) return params
				const [path, queryStr] = hash.split('?')
				if (!queryStr) return params
				const searchParams = new URLSearchParams(queryStr)
				for (const [key, value] of searchParams.entries()) {
					params[key] = decodeURIComponent(value)
				}
				return params
			},
			async checkUrlQrParams() {
				
				if (this.autoLoginFlag) return
				this.autoLoginFlag = true
				
				try {
					const params = this.getHashParams()
					console.log('params',params)
					const dataStr = params.data
					if (!dataStr) {
						return
					}
					this.loginOpen('免密登陆中...')
					this.loginType = 'qrcode'
					this.msg = '自动登录中...'
					await this.callLoginByToken(dataStr)
				} catch (err) {
					this.noLogin()
					this.$message.error('自动登录失败：' + err.message)
				} finally {
					this.autoLoginFlag = false

				}
			},
			async callLoginByToken(loginToken) {
				if (!loginToken) return
				let list = loginToken.indexOf('|') > -1 ? loginToken.split('|') : [loginToken, '']
				if (list.length < 2) list[1] = ''
				try {
					const res = await this.API.post(this.API.fileurl.postLoginQr, {
						qrCode: list[0].trim(),
						sign: list[1].trim()
					})
					
					
					if (res.data.code == 200) {
						logUserText(res)
						
						if(res.data.data.userType==3){
							this.$nextTick(() => {
								this.noLogin()
								this.$message.success('免登成功！')
								this.$router.push('/student/home')
							})
						}else{
							await userInfo()
							this.$nextTick(() => {
								this.noLogin()
								this.$message.success('免登成功！')
								this.$router.push('/teacher')
							})
						}
						
					} else {
						this.noLogin()
						this.$message.error('免登失败：' + (res.data.msg || res.msg))
					}
				} catch (err) {
					this.noLogin()
					this.$message.error('免登接口失败')
				} finally {

				}
			},
			handleQrCodeData(qrData) {
				try {
					let loginToken = qrData
					const queryIndex = qrData.indexOf('?')
					if (queryIndex > -1) {
						const queryStr = qrData.slice(queryIndex + 1)
						const params = new URLSearchParams(queryStr)
						loginToken = params.get('data') || qrData
					}
					this.callLoginByToken(loginToken)
				} catch (err) {
					this.showMask = false
					this.$message.error('解析失败')
				}
			}
		}
	}
</script>

<style scoped>
	/* 你原有样式完全不变 */
	.tab {
		display: flex;
		margin-bottom: 15px;
	}

	.tab span {
		flex: 1;
		text-align: center;
		padding: 6px;
		cursor: pointer;
	}

	.tab span.on {
		color: #2d8cf0;
		font-weight: bold;
	}

	.input {
		width: 100%;
		height: 40px;
		margin-bottom: 10px;
		padding: 0 10px;
		border: 1px solid #ddd;
		box-sizing: border-box;
	}

	.btn {
		width: 100%;
		height: 42px;
		background: #2d8cf0;
		color: #fff;
		border: none;
		cursor: pointer;
	}

	.scan-box {
		text-align: center;
		padding: 10px 0;
	}

	.upload-btn {
		padding: 8px 20px;
		background: #2d8cf0;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
	}

	.tip {
		margin-top: 10px;
		color: #2d8cf0;
		min-height: 20px;
	}

	.mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
	}

	.mask-content {
		background: #fff;
		padding: 25px 35px;
		border-radius: 8px;
	}

	.loading-text {
		font-size: 14px;
		color: #333;
	}

	/* 全平台兼容摄像头样式 */
	.camera-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #000;
		z-index: 9998;
	}

	video {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.scan-line {
		position: absolute;
		top: 40%;
		left: 10%;
		width: 80%;
		height: 2px;
		background: #2d8cf0;
		animation: scan 1.2s infinite;
	}

	@keyframes scan {
		0% {
			top: 30%;
		}

		50% {
			top: 60%;
		}

		100% {
			top: 30%;
		}
	}

	.close-camera {
		position: absolute;
		bottom: 50px;
		left: 50%;
		transform: translateX(-50%);
		background: #fff;
		padding: 8px 25px;
		border-radius: 20px;
		border: none;
	}

	.camera-btn {
		background: #00b42A !important;
	}
</style>